import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import {
  UserOutlined,
  FileTextOutlined,
  DollarOutlined,
  BarChartOutlined,
  ExclamationCircleOutlined,
  LogoutOutlined,
  DashboardOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase/config';
import Dashboard from './pages/Dashboard/Dashboard';
import LawyerVerification from './pages/LawyerVerification/LawyerVerification';
import LawyerApplications from './pages/LawyerApplications/LawyerApplications';
import Organizations from './pages/Organizations/Organizations';
import UserManagement from './pages/UserManagement/UserManagement';
import WalletMonitor from './pages/WalletMonitor/WalletMonitor';
import Withdrawals from './pages/Withdrawals/Withdrawals';
import Analytics from './pages/Analytics/Analytics';
import FraudDetection from './pages/FraudDetection/FraudDetection';
import LoginPage from './pages/Auth/LoginPage';

const { Header, Sider, Content } = Layout;

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user] = useAuthState(auth);

  const menuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    { key: '/lawyers', icon: <FileTextOutlined />, label: 'Therapist Verification' },
    { key: '/applications', icon: <SolutionOutlined />, label: 'Therapist Applications' },
    { key: '/organizations', icon: <DollarOutlined />, label: 'Organizations' },
    { key: '/users', icon: <UserOutlined />, label: 'Users' },
    { key: '/wallet', icon: <DollarOutlined />, label: 'Wallet Monitor' },
    { key: '/withdrawals', icon: <DollarOutlined />, label: 'Withdrawals' },
    { key: '/fraud', icon: <ExclamationCircleOutlined />, label: 'Fraud Detection' },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null}>
        <div style={{
          height: 60, display: 'flex', alignItems: 'center',
          justifyContent: 'center', color: 'white', fontSize: 18,
          fontWeight: 'bold', background: 'rgba(255,255,255,0.1)',
          margin: 8, borderRadius: 8,
        }}>
          Rightly Admin
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header style={{
          padding: '0 24px', background: '#fff',
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        }}>
          <div>{user?.email}</div>
          <Button type="primary" danger icon={<LogoutOutlined />} onClick={() => auth.signOut()}>
            Logout
          </Button>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff' }}>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/lawyers" element={<LawyerVerification />} />
            <Route path="/applications" element={<LawyerApplications />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/wallet" element={<WalletMonitor />} />
            <Route path="/withdrawals" element={<Withdrawals />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/fraud" element={<FraudDetection />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

function App() {
  const [user, loading] = useAuthState(auth);
  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div>Loading...</div>
    </div>
  );
  if (!user) return <LoginPage />;
  return (
    <Router>
      <AdminLayout />
    </Router>
  );
}

export default App;